import React, { ReactNode } from 'react';
import { Buttons, Dialog, FormGrid, OccupyFreeSpace } from '../../../primitives';
import { FormControlsForFields, MaybeFieldDefinition } from '../../../schemed';
import isHotkey from 'is-hotkey';
import { SlateElementEditData } from './useSlateElementEdit';
import { Schema } from '../../../../hooks/useSchema';
import { IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';


export interface DialogFieldsSection {
  columns: string;
  fields: MaybeFieldDefinition[];
}

interface Props<T extends Record<string, any>> {
  data: SlateElementEditData<T>;
  title: ReactNode;
  schema: Schema;
  sections: DialogFieldsSection[];
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
}

export function SlateElementEditDialog<T extends Record<string, any>>(props: Props<T>) {
  const { data, title, schema, sections, maxWidth = "sm" } = props;

  if (!data.editingContext) {
    return null;
  }

  return (
    <Dialog
      isOpen={!!data.editingContext}
      close={() => {
        data.completeEditing();
      }}
      onKeyDown={e => {
        if (isHotkey("mod+Enter", e)) {
          data.completeEditing();
        }
      }}
      dialogTitle={title}
      titleActions={<>
        <Buttons>
          <OccupyFreeSpace />
          <IconButton size="small" onClick={() => data.completeEditing()}><Close /></IconButton>
        </Buttons>
      </>}
      maxWidth={maxWidth}
      fullWidth
      noFullscreen>

      {sections.map((section, index) => (
        <FormGrid
          key={index}
          columns={section.columns}
          contentEditable={false}
          style={{ marginBottom: index < sections.length - 1 ? '16px' : 0 }}
        >
          <FormControlsForFields
            fields={section.fields}
            schema={schema}
            data={data.elementEdit}
            onChange={(o, c) => data.update(c as Partial<T>)}
          />
        </FormGrid>
      ))}
      
    </Dialog>
  );
}